<template>
  <div>
    <slot name="reference" />
    <div
      v-show="open"
      class="overlay"
      ref="overlay"
      @click="checkOutsideClick"
      @keydown.esc.prevent="close"
    >
      <ui-focus-lock :disabled="noFocus || !open">
        <div class="popover" ref="popover" :style="popStyle">
          <slot />
        </div>
      </ui-focus-lock>
    </div>
  </div>
</template>

<script>
import throttle from "lodash/throttle";
export default {
  data() {
    return {
      popStyle: {},
      reposition: throttle(this.repos, 50)
    };
  },
  props: {
    noFocus: Boolean,
    open: Boolean,
    parent: { default: () => document.body }
  },
  methods: {
    repos() {
      if (!this.open) return;
      const {
        top,
        bottom,
        left,
        right,
        width
      } = this.$el.getBoundingClientRect();
      const { clientWidth, clientHeight } = document.documentElement;
      const spaceTop = top;
      const spaceBottom = clientHeight - bottom;
      const spaceLeft = left;
      const spaceRight = clientWidth - right;
      let newPopStyle = { minWidth: `${width}px` };
      if (spaceBottom > spaceTop) {
        newPopStyle.top = `${bottom}px`;
        newPopStyle.bottom = 0;
        newPopStyle.alignItems = "flex-start";
      } else {
        newPopStyle.top = 0;
        newPopStyle.bottom = `${clientHeight - top}px`;
        newPopStyle.alignItems = "flex-end";
      }
      if (spaceLeft < spaceRight) {
        newPopStyle.left = `${left}px`;
      } else {
        newPopStyle.right = `${clientWidth - right}px`;
      }
      this.popStyle = newPopStyle;
    },
    close() {
      this.$emit("update:open", false);
    },
    checkOutsideClick(event) {
      if (!this.open) return;
      if (
        this.$refs.popover?.contains(event.target) &&
        this.$refs.popover !== event.target
      ) {
        return;
      }
      if (this.$el?.contains(event.target)) return;
      this.close();
    }
  },
  mounted() {
    window.addEventListener("resize", this.reposition);
    window.addEventListener("wheel", this.reposition);
    this.parent.appendChild(this.$refs.overlay);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.reposition);
    window.removeEventListener("wheel", this.reposition);
    this.reposition.cancel();
    // The overlay covers the viewport and swallows every click, so it must never
    // outlive the component. remove() detaches it from whatever parent it ended
    // up in, where removeChild throws if it is not the expected one -- and a
    // throw here would leave the page permanently unclickable.
    this.$refs.overlay?.remove();
  },
  watch: {
    open() {
      if (this.open) this.reposition();
    }
  }
};
</script>

<style scoped lang="scss">
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.popover {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  margin: 0 auto;
}
</style>
